<template>
  <div class="flex min-h-screen bg-black bg-opacity-75">
    <div class="mx-auto my-auto lg:w-1/3 xl:w-1/5">
      <div class="mb-10">
        <img
          class="w-4/5 mx-auto"
          :src="require(`@/assets/urban-logo-dark.png`)"
        />
      </div>
      <form
        class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
        action
        @submit.prevent="login"
      >
        <label class="block text-gray-700 text-sm font-bold mb-2" for="email"
          >Email:</label
        >
        <input
          v-model="email"
          class="
            shadow
            appearance-none
            border
            rounded
            w-full
            py-2
            px-3
            text-gray-700
            leading-tight
            focus:outline-none
            focus:shadow-outline
          "
          type="email"
          id="email"
          placeholder="Email"
          required
        />
        <label class="block text-gray-700 text-sm font-bold my-2" for="password"
          >Password:</label
        >
        <input
          v-model="password"
          autocomplete="current-password"
          class="
            shadow
            appearance-none
            border
            rounded
            w-full
            py-2
            px-3
            text-gray-700
            mb-3
            leading-tight
            focus:outline-none
            focus:shadow-outline
          "
          type="password"
          id="password"
          placeholder="Password"
        />
        <p v-if="error" class="error text-sm mb-3">
          {{ $t("login_error_message") }}
        </p>
        <div>
          <button
            class="
              bg-blue-500
              hover:bg-blue-700
              flex
              justify-center
              items-center
              text-white
              font-bold
              py-1
              px-4
              rounded
              cursor-pointer
              focus:outline-none
              focus:shadow-outline
            "
            type="submit"
          >
            <div class="my-1">Login</div>
            <FacebookLoader
              v-if="loading"
              :color="'#FFFFFF'"
              :size="24"
              class="ml-2 my-1"
            />
          </button>
        </div>
      </form>
      <div class="mb-10 logo-footer">  <!--Afegit des d'aqui--> 
        <img
          class="w-4/5 mx-auto"
          :src="require(`@/assets/logo-solar.png`)"
        />
      </div> <!--Fins aqui-->
    </div>
  </div>
</template>
<script>
/**
 * Vista de Login
 * --------------------------------------------
 *
 * Vista de login con el formulario para poder entrar a la página principal.
 *
 */
import { loginUser } from "@/utils/AuthService.js";
import { FacebookLoader } from "vue-spinners-css";

export default {
  /**
   * Componente loader FacebookLoader para mostrar el estado de la carga del login.
   */
  components: { FacebookLoader },
  data() {
    return {
      email: "",
      password: "",
      error: false,
      loading: false,
    };
  },
  methods: {
      /**
      * Función que se ejecuta a partir del botón de login para iniciar sesión.
      * El loader se muestra mientras está cargando y oculta cuando ha terminado la petición y devuelve una respuesta de ok o de error.
      */  
    async login() {
      this.loading = true;
      try {
        /**
         * le pasamos el correo y la contraseña para poder autenticarnos.
         */
        await loginUser(this.email, this.password);
        this.error = false;
        this.$router.push("/map");
      } catch (err) {
        this.error = true;
        /**
         * Si falla la autenticación mostramos un mensaje de error de desaparece automáticamente en 3.5 segundos
         */
        setTimeout(() => this.error = false, 3500)
      }
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.error {
  color: red;
}
.mb-10.logo-footer {
    margin-top: 2.5rem;
}
</style>